module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-miceneurol-2-e87796ca1be54aae3fda952476f69491.png";